/* 🤖 this file was generated by svg-to-ts */
export const mgcIconMoonCuteFi: {
  name: 'moon-cute-fi';
  data: string;
} = {
  name: 'moon-cute-fi',
  data: `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"><path fill="currentColor" fill-rule="evenodd" d="M13.78 3.376a1.53 1.53 0 0 0-1.064 1.209c-.047.254-.028.454.082.875.155.594.182.835.179 1.58-.002.601-.019.813-.089 1.13-.535 2.435-2.291 4.197-4.7 4.718-.335.072-.541.088-1.148.09-.76.002-1.015-.028-1.6-.19-.408-.113-.861-.11-1.171.01a1.634 1.634 0 0 0-.813.771c-.102.221-.116.294-.113.611.003.311.024.418.154.78 1.149 3.2 3.9 5.457 7.245 5.945.977.142 2.301.083 3.298-.147 2.538-.587 4.769-2.331 5.96-4.658a9.006 9.006 0 0 0-1.66-10.48 8.786 8.786 0 0 0-2.4-1.701c-1.056-.516-1.719-.683-2.16-.543"/></svg>`
};
